import axios from "../../lib/axiosInstance";

export function createTeamTask(payload) {
  return axios.post(`teamTasks`, payload).then((res) => res.data);
}

export function deleteTask(id) {
  return axios.delete(`teamTasks/${id}`).then((res) => res.data);
}

export function fetchAllTeamTask(payload) {
  const params = {};

  if (payload.taskIds?.length) params.taskIds = payload.taskIds.join(",");
  if (payload.assignees?.length) params.assignees = payload.assignees.join(",");
  if (payload.createdByIds?.length) params.createdByIds = payload.createdByIds.join(",");
  if (payload.workOrderIds) params.workOrderIds = payload.workOrderIds;
  if (payload.priority) params.priority = payload.priority;
  if (payload.search) params.search = payload.search;
  if (payload.teamIds?.length) params.teamIds = payload.teamIds.join(",");
  if (payload.status) params.status = payload.status;
  if (payload.page) params.page = payload.page;
  if (payload.pageSize) params.pageSize = payload.pageSize;

  return axios.get(`teamTasks`, { params }).then((res) => res.data);
}

export function fetchTaskById(id) {
  return axios.get(`teamTasks/${id}`).then((res) => res.data);
}

export function updateTaskStatus(payload) {
  return axios
    .patch(`teamTasks/status/${payload.taskId}/${payload.status}`)
    .then((res) => res.data);
}

export function updateTeamTask(formData) {
  const id = formData.get("id"); // get id from FormData

  return axios
    .patch(`teamTasks/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data);
}

export function deleteTaskAttachement(id) {
  return axios.delete(`teamTasks/attachment/${id}`).then((res) => res.data);
}

export function createTaskComment(payload) {
  const { id, ...rest } = payload;
  return axios.post(`teamTasks/${id}/comments`, rest).then((res) => res.data);
}

export function updateTaskComment(payload) {
  const { id, ...rest } = payload;
  return axios.patch(`teamTasks/comments/${id}`, rest).then((res) => res.data);
}
